module.exports = __webpack_public_path__ + "img/suzuki-grand-vitara-boostergreen.df312be4.jpg";